import emiliaPic from "@/public/images/artists/emilia.png";
import { Artist } from "@/types/types";

export const emilia = {
  id: "118",
  name: "Emilia",
  image: emiliaPic,
  description: `Emilia's vocal range is defined by commanding belting, effortlessly transitioning into a soaring upper register marked by impressive agility.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Femilia-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Pop", "Dance", "Belting"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Very high",
      },
      specific: {
        low: 55,
        high: 74,
      },
    },
  },
} as const satisfies Artist;
